import { memoize } from 'lodash';

// http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
const regExpEscapeReg = /[-\/\\^$*+?.()|\[\]{}]/g;

export function escapeRegexpString(regExpString: string): string {
    return regExpString.replace(regExpEscapeReg, '\\$&');
}

export const unescapeHtmlSymbolCodes = memoize((str: string): string => {
    return (str || '').replace(/&#(\d+);/g, (s, c) => String.fromCharCode(c));
});
